import { useQuery } from '@tanstack/react-query';

import { services } from '../../services';

export const useGetDashboardSummary = () => {
  return useQuery([`DashboardSummary`], () => services.getDashboardSummary());
};
